require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./truncatedtext"), require("./flexlayout"), require("./container"), require("./tooltip"), require("./flyout"), require("./toolbar"), require("./slideout"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./truncatedtext", "./flexlayout", "./container", "./tooltip", "./flyout", "./toolbar", "./slideout"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./truncatedtext"), require("./flexlayout"), require("./container"), require("./tooltip"), require("./flyout"), require("./toolbar"), require("./slideout")) : factory(root["./utils"], root["./svgicon"], root["./truncatedtext"], root["./flexlayout"], root["./container"], root["./tooltip"], root["./flyout"], root["./toolbar"], root["./slideout"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__25__, __WEBPACK_EXTERNAL_MODULE__28__, __WEBPACK_EXTERNAL_MODULE__87__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[59],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__14__;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-tabList__item .ba-common-tabList__itemIcon{display:none}use{pointer-events:none}.ba-common-tabList .ba-common-tabList__inner{display:flex;align-items:center}.ba-common-tabList .ba-common-tabList__inner .ba-common-tabList__list{width:fit-content;overflow-x:hidden;overflow-y:hidden}.ba-common-tabList.is-addable .ba-common-tabList__edge__wrapper{user-select:none}.ba-common-tabList.is-addable .ba-common-tabList__edge__wrapper.is-right{right:28px}.ba-common-flyout__container.tab-item-flyout-container{margin-top:8px;padding:0px;width:auto}.ba-common-flyout__container.tab-item-flyout-container .ba-common-toolbar{margin-top:0px;margin-bottom:0px}.ba-common-flyout__container.tab-item-flyout-container .ba-common-toolbar .ba-common-toolbar__item{margin-bottom:0px;padding:4px;cursor:pointer}.flyout-wrapper{display:inline-flex}.ba-common-tabList.is-vertical>div{height:100%}.ba-common-tabList.is-vertical .ba-common-tabList__itemDraggable{display:block}.ba-common-tabList.is-vertical .ba-common-tabList__list{padding-bottom:6px}.ba-common-tabList.is-vertical .flyout-wrapper{display:block}.ba-common-tabList.is-vertical .ba-common-tabList__inner .ba-common-tabList__list{padding-bottom:2px}.ba-common-tabList.is-vertical .ba-common-tabList__inner{display:flex;align-items:center;height:100%}.ba-common-tabList.is-vertical .ba-common-tabList__inner .ba-common-tabList__list{max-height:calc(100% - 40px);max-width:none;width:fit-content;overflow-y:hidden;overflow-x:hidden}.ba-common-tabList.is-vertical .ba-common-tabList__edge__wrapper.is-bottom{height:32px;bottom:28px}.ba-common-tabList.is-vertical .ba-common-tabList__edge__wrapper.is-top{height:32px}.ba-common-tabList__container{height:100%;width:100%}.ba-common-tabList__container.is-clicked .ba-common-tabList__item:focus{border-color:transparent}.ba-common-tabList__container:not(.is-vertical){display:flex;flex-direction:column}.ba-common-tabList__container .ba-common-tabList__innerContainer{height:calc(100% - 40px);width:100%}.ba-common-tabList__container.is-align_center .ba-common-tabList__inner{justify-content:center}.ba-common-tabList__container.is-align_end .ba-common-tabList__inner{justify-content:flex-end}.ba-common-tabList__container>.ba-common-flexLayout-item{padding-top:0px !important}.ba-common-tabList__container .tabpanel{width:100%;height:100%}.ba-common-tabList__container.is-vertical{display:flex}.ba-common-tabList__container.is-vertical .ba-common-tabList__innerContainer{height:100%}.ba-common-tabList__container.is-vertical .ba-common-tabList{height:auto}.ba-common-tabList__container.is-vertical .ba-common-tabList.is-vertical{border-bottom-width:0px;border-right-width:1px}.ba-common-tabList__container.is-vertical .ba-common-tabList__list{width:100%}.ba-common-tabList__container.is-vertical .ba-common-tabList__inner{padding-bottom:initial}.ba-common-tabList__container.is-vertical .ba-common-tabList__item{display:flex;justify-content:flex-start;height:48px}.ba-common-tabList__container.is-vertical .ba-common-tabList__item .subTitle{text-align:center}.ba-common-tabList__container.is-vertical .ba-common-svgIcon.is-small.is-clickable.addNewIcon{display:block !important;margin-left:auto;margin-right:auto;position:relative;z-index:99;top:auto;bottom:-20px}.ba-common-tabList__container.is-vertical .ba-common-tabList__inner{flex-direction:column}.ba-common-tabList__container.is-vertical .ba-common-tabList__inner .ba-common-tabList__list{overflow-x:hidden;overflow-y:hidden;height:auto}.ba-common-tabList__container.is-vertical .ba-common-tabList__inner::-webkit-scrollbar{width:0px;background:transparent}.ba-common-tabList__container.is-vertical .ba-common-tabList{height:100% !important}.ba-common-tabList__container.is-slideout{width:auto}.ba-common-tabList__container.is-slideout .ba-common-tabList__item{height:48px}.ba-common-tabList__container.is-slideout .ba-common-tabList__item[aria-selected=true]{background-color:#fff}.ba-common-tabList__container.is-slideout>.ba-common-container.ba-common-flexLayout-item .ba-common-slideout-children-wrapper{box-shadow:inset -1px 0px #eaeaea}.ba-common-tabList__container.is-slideout>.ba-common-container.ba-common-flexLayout-item .ba-common-tabList{background-color:#eaeaea;z-index:2}@media screen and (-ms-high-contrast: active){.ba-common-tabList__container .ba-common-svgIcon.is-small.is-clickable.addNewIcon{fill:#fff}}.ba-common-tabList__container.tabs-placement-top{flex-direction:column}.ba-common-tabList__container.tabs-placement-top .ba-common-tabList{border-bottom-width:1px}.ba-common-tabList__container.tabs-placement-bottom{flex-direction:column-reverse}.ba-common-tabList__container.tabs-placement-bottom .ba-common-tabList{border-top-width:1px}.ba-common-tabList__container.tabs-placement-left{flex-direction:row}.ba-common-tabList__container.tabs-placement-left .ba-common-tabList{border-right-width:1px}.ba-common-tabList__container.tabs-placement-right{flex-direction:row-reverse}.ba-common-tabList__container.tabs-placement-right .ba-common-tabList{border-left-width:1px}.ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-top .ba-common-tabList[aria-selected=true]{box-shadow:0px 2px 0 #0f62fe inset;box-shadow:0px 2px 0 var(--interactive-01, #0f62fe) inset}.ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-left .ba-common-tabList__item[aria-selected=true]{box-shadow:2px 0px 0 #0f62fe inset;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset}.ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]{box-shadow:-2px 0px 0 #0f62fe inset;box-shadow:-2px 0px 0 var(--interactive-01, #0f62fe) inset}.ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=true]{box-shadow:0px -2px 0 #0f62fe inset;box-shadow:0px -2px 0 var(--interactive-01, #0f62fe) inset}.ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-none .ba-common-tabList__item[aria-selected=true]{box-shadow:0 0 0 2px #002d9c inset;box-shadow:0 0 0 2px var(--active-primary, #002d9c) inset}.ba-common-tabList__list{height:54px;-ms-overflow-style:none}.ba-common-tabList__list::-webkit-scrollbar{display:none}.ba-common-tabList__list.line-position-top .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:0px 2px 0 #8d8d8d inset;box-shadow:0px 2px 0 var(--ui-04, #8d8d8d) inset}.ba-common-tabList__list.line-position-top .ba-common-tabList__item[aria-selected=true]{box-shadow:0px 2px 0 #0f62fe inset;box-shadow:0px 2px 0 var(--interactive-01, #0f62fe) inset}@media screen and (-ms-high-contrast: active){.ba-common-tabList__list.line-position-top .ba-common-tabList__item[aria-selected=true]{border:solid #fff}}.ba-common-tabList__list.line-position-top .ba-common-tabList__item[aria-selected=true]:focus{box-shadow:0px 2px 0 #0f62fe inset,inset 0px 0px 0px 2px #0f62fe;box-shadow:0px 2px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px #0f62fe}.ba-common-tabList__list.line-position-top .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon{height:calc(100% - 4px);top:4px}.ba-common-tabList__list.line-position-top .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon .ba-common-svgIcon{top:calc(50% - 10px);left:calc(50% - 8px)}.ba-common-tabList__list.line-position-left .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:2px 0px 0 #8d8d8d inset;box-shadow:2px 0px 0 var(--ui-04, #8d8d8d) inset}.ba-common-tabList__list.line-position-left .ba-common-tabList__item[aria-selected=true]{box-shadow:2px 0px 0 #0f62fe inset;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset}@media screen and (-ms-high-contrast: active){.ba-common-tabList__list.line-position-left .ba-common-tabList__item[aria-selected=true]{border:solid #fff}}.ba-common-tabList__list.line-position-left .ba-common-tabList__item[aria-selected=true]:focus{box-shadow:2px 0px 0 #0f62fe inset,inset 0px 0px 0px 2px #0f62fe;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px #0f62fe}.ba-common-tabList__list.line-position-right .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:-2px 0px 0 #8d8d8d inset;box-shadow:-2px 0px 0 var(--ui-04, #8d8d8d) inset}.ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]{box-shadow:-2px 0px 0 #0f62fe inset;box-shadow:-2px 0px 0 var(--interactive-01, #0f62fe) inset}@media screen and (-ms-high-contrast: active){.ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]{border:solid #fff}}.ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]:focus{box-shadow:-2px 0px 0 #0f62fe inset,inset 0px 0px 0px 2px #0f62fe;box-shadow:-2px 0px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px #0f62fe}.ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon{width:20px;right:4px}.ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon .ba-common-svgIcon{top:calc(50% - 8px);left:calc(50% - 6px)}.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:0px -2px 0 #8d8d8d inset;box-shadow:0px -2px 0 var(--ui-04, #8d8d8d) inset}.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=true]{box-shadow:0px -2px 0 #0f62fe inset;box-shadow:0px -2px 0 var(--interactive-01, #0f62fe) inset}@media screen and (-ms-high-contrast: active){.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=true]{border:solid #fff}}.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=true]:focus{box-shadow:0px -2px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px #0f62fe;box-shadow:0px -2px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px #0f62fe}.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon{height:calc(100% - 4px);bottom:4px}.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon .ba-common-svgIcon{top:calc(50% - 6px);left:calc(50% - 8px)}.ba-common-tabList__list.line-position-none .ba-common-tabList__item[aria-selected=true]{box-shadow:0 0 0 2px #002d9c inset;box-shadow:0 0 0 2px var(--active-primary, #002d9c) inset}@media screen and (-ms-high-contrast: active){.ba-common-tabList__list.line-position-none .ba-common-tabList__item[aria-selected=true]{background-color:#fff;color:#000}}.ba-common-tabList__list.line-position-none .ba-common-tabList__item[aria-selected=true]:focus{box-shadow:inset 0px 0px 0px 2px #0f62fe;box-shadow:inset 0px 0px 0px 2px var(--focus, #0f62fe)}.ba-common-tabList.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{display:inline-flex}.ba-common-tabList .ba-common-svgIcon.is-small.is-clickable.addNewIcon{display:none;color:#8d8d8d}.ba-common-tabList .ba-common-svgIcon.is-small.is-clickable.addNewIcon:hover{color:#0f62fe}.ba-common-tabList .tabContent{margin-top:32px;height:100%}.ba-common-tabList .tabContent .Heading:first-child{margin-top:0}.ba-common-tabList.is-only-icon-tab-list .ba-common-tabList__item{height:48px;width:48px;padding-left:12px;padding-right:12px}.ba-common-tabList.is-only-icon-tab-list .ba-common-tabList__item:focus{padding-left:12px;padding-right:12px}.ba-common-tabList.is-only-icon-tab-list .ba-common-svgIcon.is-small.is-clickable.addNewIcon{margin-top:16px;margin-bottom:16px;top:-4px}.ba-common-tabList.is-vertical .ba-common-tabList__item{height:48px}.ba-common-tabList.is-vertical .ba-common-svgIcon.is-small.is-clickable.addNewIcon{bottom:-8px}.ba-common-tabList .ba-common-tabList__item{height:40px;box-sizing:border-box}.ba-common-tabList .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{position:absolute;background-color:#eaeaea;height:100%;width:24px;right:0;top:0}.ba-common-tabList .ba-common-tabList__item:hover .ba-common-tabList__itemIcon .ba-common-svgIcon{color:#595859;position:absolute;top:calc(50% - 8px);left:calc(50% - 8px)}.ba-common-tabList .ba-common-tabList__item .ba-common-tabList__label{text-align:center}.ba-common-tabList .ba-common-tabList__item .ba-common-tabList__label.is-only-icon-tab{margin-right:0px;color:#595859}.ba-common-tabList.is-addable .ba-common-svgIcon.is-small.is-clickable.addNewIcon{display:inline}.ba-common-tabList .subTitle{display:none;text-overflow:ellipsis;overflow:hidden}.ba-common-tabList{text-align:left;overflow:hidden;height:40px;position:relative;border-width:0;border-bottom-width:1px;border-style:solid}.ba-common-tabList.is-editable .ba-common-tabList__label{font-size:.875rem;line-height:carbon--rem(18px);position:relative}.ba-common-tabList.is-editable .ba-common-tabList__label .ba-common-tabList__labelText:focus{outline:none;font-weight:600;text-overflow:initial;cursor:text}.ba-common-tabList.is-editable .ba-common-tabList__label .ba-common-tabList__labelText:focus .is-removeTextIcon{display:inherit}.ba-common-tabList .is-removeTextIcon{position:absolute;display:none;top:16px;right:8px;color:#595859;z-index:1000}.ba-common-tabList div.ba-common-tabList__item:focus .is-removeTextIcon{display:inline-block}.ba-common-tabList.is-only-icon-tab-list{height:48px}.ba-common-tabList__edge__wrapper{position:absolute;pointer-events:visible;opacity:0;display:none}@media screen and (-ms-high-contrast: active){.ba-common-tabList__edge__wrapper{border:solid #fff}}.ba-common-tabList__edge__wrapper .ba-common-tabList__edge{width:16px}.ba-common-tabList__edge__wrapper.is-left{left:0;top:0;bottom:0;width:16px}.ba-common-tabList__edge__wrapper.is-right{right:0;top:0;bottom:0}.ba-common-tabList__edge__wrapper.is-top{top:0px}.ba-common-tabList__edge__wrapper.is-bottom{bottom:0px}.ba-common-tabList__edge__wrapper.is-visible{opacity:1;pointer-events:visible;display:block}.ba-common-tabList__inner{position:relative;white-space:nowrap;overflow-x:auto;overflow-y:hidden;padding-bottom:50px;display:flex}.ba-common-tabList__line{height:4px;border:0;border-bottom-width:4px;border-style:solid;position:absolute;left:0;bottom:0;margin:0}.ba-common-tabList__line.is-above{top:0px}.ba-common-tabList__line.is-hidden{display:none}.ba-common-tabList__list{margin:0;padding:0;position:relative;display:inline-block}.ba-common-tabList__list .is-dragging{opacity:0;z-index:auto !important;cursor:grab}.ba-common-tabList__itemDraggable{display:inline-block;vertical-align:middle}.ba-common-tabList__item{user-select:none;vertical-align:middle;display:inline-flex;align-content:center;justify-content:center;align-self:center;cursor:pointer;outline:0;height:40px;padding:0 8px;padding-right:24px;line-height:32px;position:relative;padding-left:16px;padding-right:16px;margin-left:0px;min-width:48px;max-width:300px;border:solid 2px transparent}.ba-common-tabList__item .ba-common-tabList__label__container{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center}.ba-common-tabList__itemIcon{display:inline-block}.ba-common-tabList__item.is-label{min-width:48px}.ba-common-tabList__item.is-label .ba-common-tabList__labelIcon{order:2;margin-left:8px}.ba-common-tabList__item.is-label .ba-common-tabList__labelIcon.is-left-positioned-icon{order:0;margin-left:0px;margin-right:8px}.ba-common-tabList__item.is-label .ba-common-tabList__labelIcon.is-top-positioned-icon{margin:0 auto;order:0}.ba-common-tabList__item.is-label .ba-common-tabList__labelIcon.is-bottom-positioned-icon{margin:0 auto 4px}.ba-common-tabList__item.is-label.is-disabled{opacity:.5;cursor:not-allowed;background-color:initial}.ba-common-tabList__item .ba-common-tabList__label{font-size:.875rem;font-weight:600;width:auto;text-overflow:ellipsis;overflow:hidden;line-height:normal;align-self:center;display:flex;flex-flow:row wrap}.ba-common-tabList__item .ba-common-tabList__labelText{order:1;text-overflow:ellipsis;white-space:nowrap;max-width:268px;outline:none}.ba-common-tabList__item .ba-common-tabList__labelText.is-top-positioned-icon,.ba-common-tabList__item .ba-common-tabList__labelText.is-bottom-positioned-icon{flex:1 0 100%;display:flex;justify-content:center}.ba-common-tabList .ba-common-tabList__labelIcon{align-self:center}.ba-common-tabList .ba-common-svgIcon.is-small.is-clickable.addNewIcon{top:calc(50% - 8px);margin:12px 12px 12px 12px;z-index:auto;right:0px;top:-8px;position:relative}.ba--highContrast .ba-common-tabList__edge{width:1px;border:0 solid transparent;border-left-width:1px;visibility:hidden}.ba--highContrast .ba-common-tabList__edge.is-visible{visibility:visible}.ba--highContrast .ba-common-tabList__line.is-under{border-style:double;border-bottom-width:2px}.ba-common-tabList__item.is-selected.is-editable .ba-common-tabList__labelText:focus{font-weight:normal;-webkit-user-select:text}.ba-common-tabList{transition:border-color .2s ease-in-out;border-color:#eaeaea}.ba-common-tabList__edge__wrapper{transition:opacity .2s ease-in-out;background-color:#fff;width:32px;z-index:100}.ba-common-tabList__edge__wrapper .chevron-icon{cursor:pointer;pointer-events:visible}.ba-common-tabList__edge__wrapper.is-left{width:32px}.ba-common-tabList__edge__wrapper.is-left .ba-common-tabList__edge{right:0px;position:absolute}.ba-common-tabList__edge__wrapper.is-left .chevron-icon{position:absolute;top:calc(50% - 8px);right:8px;transform:rotate(180deg)}.ba-common-tabList__edge__wrapper.is-top{height:32px;width:100%}.ba-common-tabList__edge__wrapper.is-top .ba-common-tabList__edge{background:linear-gradient(to bottom, rgba(52, 51, 52, 0.2) 0%, rgba(0, 0, 0, 0) 100%);bottom:0px;position:absolute;height:8px;width:100%}.ba-common-tabList__edge__wrapper.is-top .chevron-icon{position:absolute;top:0px;left:calc(50% - 8px);transform:rotate(270deg)}.ba-common-tabList__edge__wrapper.is-bottom{height:32px;width:100%}.ba-common-tabList__edge__wrapper.is-bottom .ba-common-tabList__edge{background:linear-gradient(to bottom, rgba(52, 51, 52, 0.2) 0%, rgba(0, 0, 0, 0) 100%);top:0px;position:absolute;height:8px;width:100%}.ba-common-tabList__edge__wrapper.is-bottom .chevron-icon{position:absolute;bottom:0px;left:calc(50% - 8px);transform:rotate(90deg)}.ba-common-tabList__edge__wrapper.is-right .ba-common-tabList__edge{right:0px}.ba-common-tabList__edge__wrapper.is-right .chevron-icon{position:absolute;top:calc(50% - 8px);left:8px}.ba-common-tabList__edge__wrapper .ba-common-tabList__edge{height:100%;width:8px}.ba-common-tabList__line{transition:left .2s ease-in-out,width .2s ease-in-out;border-color:#0f62fe}.ba-common-tabList__line.is-under{border-color:#8d8d8d}.ba-common-tabList__item{transition:color .2s ease-in-out;color:#343334}.ba-common-tabList__item.is-selected{color:#161616}[dir=rtl] .ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-right .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:2px 0px 0 #8d8d8d inset;box-shadow:2px 0px 0 var(--ui-04, #8d8d8d) inset}[dir=rtl] .ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]{box-shadow:2px 0px 0 #0f62fe inset;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset}[dir=rtl] .ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon{left:4px}[dir=rtl] .ba-common-tabList__list.line-position-right .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:2px 0px 0 #8d8d8d inset;box-shadow:2px 0px 0 var(--ui-04, #8d8d8d) inset}[dir=rtl] .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]{box-shadow:2px 0px 0 #0f62fe inset;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset}@media screen and (-ms-high-contrast: active){[dir=rtl] .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]{border:solid #fff}}[dir=rtl] .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]:focus{box-shadow:2px 0px 0 #0f62fe inset,inset 0px 0px 0px 2px #0f62fe;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px var(--focus, #0f62fe)}[dir=rtl] .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon{left:4px;right:auto}[dir=rtl] .ba-common-tabList .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{left:0;right:auto}[dir=rtl] .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon{left:4px}[dir=rtl] .ba-common-tabList.is-addable .ba-common-tabList__edge__wrapper.is-left{left:0px}[dir=rtl] .ba-common-tabList.is-addable .ba-common-tabList__edge__wrapper.is-right{right:0px}.ba-common-tabList.is-tabButton{border-bottom-width:0px}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item{border:none}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{display:inline-flex;position:absolute;height:100%;width:24px;top:0;background-color:transparent}[dir=ltr].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{right:0;margin-right:2px}[dir=rtl].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{right:auto;left:0;margin-right:0;margin-left:2px}[dir=ltr] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon,.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{right:0;margin-right:2px}[dir=rtl] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{right:auto;left:0;margin-right:0;margin-left:2px}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__itemIcon .ba-common-svgIcon{fill:#fff;color:#fff;position:absolute;top:calc(50% - 8px);left:calc(50% - 8px)}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]{padding-right:0px}@media screen and (-ms-high-contrast: active){.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]{background-color:#fff;color:#000}}@media screen and (-ms-high-contrast: active){.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true] .ba-common-tabList__itemIcon .ba-common-svgIcon{fill:#000}}[dir=ltr].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]{padding-left:26px}[dir=rtl].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]{padding-left:0;padding-right:26px}[dir=ltr] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true],.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]{padding-left:26px}[dir=rtl] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]{padding-left:0;padding-right:26px}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon{height:100%}[dir=ltr].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon{margin-right:2px}[dir=rtl].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon{margin-right:0;margin-left:2px}[dir=ltr] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon,.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon{margin-right:2px}[dir=rtl] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon{margin-right:0;margin-left:2px}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true]:hover .ba-common-tabList__itemIcon .ba-common-svgIcon{top:calc(50% - 8px);left:calc(50% - 8px)}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true] .ba-common-tabList__itemIcon{display:inline-flex;position:relative;height:100%;width:24px;top:0;background-color:transparent}[dir=ltr].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true] .ba-common-tabList__itemIcon{margin-right:2px;right:0}[dir=rtl].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true] .ba-common-tabList__itemIcon{margin-right:0;margin-left:2px;right:auto;left:0}[dir=ltr] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true] .ba-common-tabList__itemIcon,.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true] .ba-common-tabList__itemIcon{margin-right:2px;right:0}[dir=rtl] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=true] .ba-common-tabList__itemIcon{margin-right:0;margin-left:2px;right:auto;left:0}.ba-common-tabList.is-tabButton .ba-common-tabList__item{border:none;box-shadow:0 0 0 2px #0f62fe inset;box-shadow:0 0 0 2px var(--interactive-01, #0f62fe) inset;padding-left:26px;padding-right:26px;color:#0f62fe;transition:none}.ba-common-tabList.is-tabButton .ba-common-tabList__item .ba-common-tabList__labelText:focus{color:inherit}[dir=ltr].ba-common-tabList.is-tabButton .ba-common-tabList__item{margin-right:8px}[dir=rtl].ba-common-tabList.is-tabButton .ba-common-tabList__item{margin-right:0;margin-left:8px}[dir=ltr] .ba-common-tabList.is-tabButton .ba-common-tabList__item,.ba-common-tabList.is-tabButton .ba-common-tabList__item{margin-right:8px}[dir=rtl] .ba-common-tabList.is-tabButton .ba-common-tabList__item{margin-right:0;margin-left:8px}@media screen and (-ms-high-contrast: active){.ba-common-tabList.is-tabButton .ba-common-tabList__item{box-shadow:inset 0px 0px 0px 2px #fff}}.ba-common-tabList.is-tabButton .ba-common-tabList__item:hover{color:#fff;background-color:#0f62fe}.ba-common-tabList.is-tabButton .ba-common-tabList__item[aria-selected=true]{color:#fff;background-color:#002d9c}@media screen and (-ms-high-contrast: active){.ba-common-tabList.is-tabButton .ba-common-tabList__item[aria-selected=true]{background-color:#fff;color:#000}}", ""]);

// exports
exports.locals = {
	"tabListClassName": "\"ba-common-tabList\""
};

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;
exports.default = exports.TabItemDnD = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _reactDom = __webpack_require__(11);

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _lodash = __webpack_require__(18);

var _utils = __webpack_require__(5);

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _tooltip = _interopRequireDefault(__webpack_require__(16));

var _close_ = _interopRequireDefault(__webpack_require__(39));

var _flyout = __webpack_require__(25);

var _toolbar = _interopRequireDefault(__webpack_require__(28));

var _reactDnd = __webpack_require__(23);

var _ItemTypes = _interopRequireDefault(__webpack_require__(196));

var _TabLabel = _interopRequireDefault(__webpack_require__(518));

__webpack_require__(55);

var _dec, _dec2, _class, _class2, _temp;

const tabSource = {
  beginDrag(props) {
    props.isDraggingCallback(true);
    return {
      id: props.panelId,
      index: props.index
    };
  }

};
const tabTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index; // Don't replace items with themselves

    if (dragIndex === hoverIndex) {
      return;
    } // Determine rectangle on screen


    const hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();

    if (props.vertical) {
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2; // Determine mouse position

      const clientOffset = monitor.getClientOffset(); // Get pixels to the top

      const hoverClientY = clientOffset.y - hoverBoundingRect.top; // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      } // Dragging upwards


      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
    } else {
      // Get horizontal middle
      const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2; // Determine mouse position

      const clientOffset = monitor.getClientOffset();

      if (clientOffset === null) {
        return;
      } // Get pixels to the left


      const hoverClientX = clientOffset.x - hoverBoundingRect.left; // Only perform the move when the mouse has crossed half of the items width
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging left

      if (dragIndex < hoverIndex && hoverClientX < hoverMiddleX) {
        component.handler.component.setState({
          dragDivider: 'left'
        });
        return;
      } // Dragging right


      if (dragIndex > hoverIndex && hoverClientX > hoverMiddleX) {
        component.handler.component.setState({
          dragDivider: 'right'
        });
        return;
      }
    } // Time to actually perform the action


    props.moveTab(dragIndex, hoverIndex, false, props.keyValue); // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.

    monitor.getItem().index = hoverIndex;
  },

  drop(props, monitor) {
    props.isDraggingCallback(false); // perform moveTab but inform that the tab has been dropped

    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    props.moveTab(dragIndex, hoverIndex, true, props.keyValue);
  }

};
let TabItemDnD = (_dec = (0, _reactDnd.DropTarget)(_ItemTypes.default.TAB, tabTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver()
})), _dec2 = (0, _reactDnd.DragSource)(_ItemTypes.default.TAB, tabSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
})), _dec(_class = _dec2(_class = (_temp = _class2 = class TabItemDnD extends _react.Component {
  render() {
    const {
      connectDragSource,
      connectDropTarget,
      ...other
    } = this.props;
    return connectDragSource(connectDropTarget( /*#__PURE__*/_react.default.createElement("div", {
      className: "ba-common-tabList__itemDraggable"
    }, ' ', /*#__PURE__*/_react.default.createElement(TabItem, other), ' ')));
  }

}, (0, _defineProperty2.default)(_class2, "propTypes", {
  connectDragSource: _propTypes.default.func.isRequired,
  connectDropTarget: _propTypes.default.func.isRequired
}), _temp)) || _class) || _class);
exports.TabItemDnD = TabItemDnD;

class TabItem extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "onKeyPress", event => {
      if (event.which === 13
      /* Enter */
      ) {
          event.preventDefault();
          event.target.blur();
        }
    });
    (0, _defineProperty2.default)(this, "onKeyDown", e => {
      const {
        deleteHandler,
        onDeletePrompt
      } = this.props;

      switch (e.keyCode) {
        // enter
        case 13:
          e.preventDefault();
          e.stopPropagation();
          this.tabLabel && this.tabLabel.focusOnLabel();

          if (this.props.toolbar) {
            this.onDoubleClickHandler();
          }

          break;
        // delete

        case 46:
          e.preventDefault();
          e.stopPropagation();

          if (this.props.deleteable) {
            if (onDeletePrompt) {
              this.deleteCallback();
            } else {
              deleteHandler && deleteHandler();
            }
          }

          break;
        // ctrl/cmd + ->

        case 39:
          if (e.ctrlKey || e.metaKey) {
            this.handleTabIncrement(e, 1);
          }

          this.closeToolbar();
          break;
        // ctrl/cmd + <-

        case 37:
          if (e.ctrlKey || e.metaKey) {
            this.handleTabIncrement(e, -1);
          }

          this.closeToolbar();
          break;

        default:
      }
    });
    (0, _defineProperty2.default)(this, "onDoubleClickHandler", () => {
      this.setState(state => ({
        flyoutOpen: !state.flyoutOpen
      }));
    });
    (0, _defineProperty2.default)(this, "closeToolbar", () => {
      this.setState({
        flyoutOpen: false
      });
    });
    (0, _defineProperty2.default)(this, "focusHandler", value => {
      this.setState({
        editActive: value
      });
    });
    (0, _defineProperty2.default)(this, "themeHoverOn", () => {
      this.setState({
        themeHover: true
      });
    });
    (0, _defineProperty2.default)(this, "themeHoverOff", () => {
      this.setState({
        themeHover: false
      });
    });
    this.state = {
      label: this.props.label,
      flyoutOpen: false,
      editActive: false,
      themeHover: false
    };
  }

  /**
   * Moves a tab via the keyboard.  Finds the tab index and calls the incrementTab callback.
   *
   * @param e {event} - keyboard event
   * @param direction {number} - direction to move the tab, 1 for right and -1 for left.
   */
  handleTabIncrement(e, direction) {
    const {
      incrementTab
    } = this.props;
    e.preventDefault();
    e.stopPropagation();

    if (incrementTab) {
      const idx = e.target.getAttribute('data-index');
      incrementTab(parseInt(idx, 10), direction, this.props.keyValue);
    }
  }

  changeHandler(event, id) {
    const newText = event.target.textContent || '\u00A0'; // If newText isEmpty, newText defaults to a blank space to ensure label prop from Tabs parent component

    this.props.onEditLabel(id, newText);
    event.target.scrollLeft = 0;
  }

  assignSvgIconColor(node, color) {
    if (node && color) {
      node.style.color = color;
    }
  }

  deleteCallback() {
    return this.props.onDeletePrompt(this.props.deleteHandler);
  }

  render() {
    const {
      selected,
      label,
      textDir,
      subTitle,
      editable,
      setSelectedNode,
      setFocusNode,
      panelId,
      onEnter,
      onLeave,
      index,
      title,
      deleteHandler,
      onDeletePrompt,
      disabled,
      isDragging,
      isOver,
      icon,
      isIconBeforeLabel,
      iconPosition,
      iconColor,
      disableDrag,
      enableDrag,
      tabButton,
      vertical,
      tooltipOrient,
      ...others
    } = this.props;
    let onClick;

    if (this.props.disabled === true) {
      onClick = e => {
        e.stopPropagation();
      };
    } else {
      onClick = this.props.onClick;
    }

    const className = (0, _utils.classnames)('ba-common-tabList__item', {
      selected,
      label: !!label,
      disabled,
      editable,
      dragging: isDragging,
      dragDivider: isOver && this.state.dragDivider,
      tabButton
    }, isOver && this.state.dragDivider ? `dragDivider-${this.state.dragDivider}` : undefined);
    let lineStyle;

    if (selected) {
      switch (this.props.linePositionClass) {
        case 'line-position-top':
          lineStyle = `0px 3px 0 ${this.props.lineColor} inset`;
          break;

        case 'line-position-left':
          lineStyle = `3px 0px 0 ${this.props.lineColor} inset`;
          break;

        case 'line-position-right':
          lineStyle = `-3px 0px 0 ${this.props.lineColor} inset`;
          break;

        case 'line-position-bottom':
          lineStyle = `0px -3px 0 ${this.props.lineColor} inset`;
          break;

        default:
          break;
      }
    }

    const themeBackgroundColor = this.state.themeHover && this.props.hoverColor ? this.props.hoverColor : this.props.backgroundColor;
    const style = { ...(this.props.backgroundColor || this.props.hoverColor ? {
        backgroundColor: themeBackgroundColor
      } : {}),
      color: this.props.textColor,
      ...(this.props.lineColor ? {
        boxShadow: lineStyle
      } : {})
    };
    const deleteStyles = { ...(this.props.deleteBackgroundColor ? {
        backgroundColor: this.props.deleteBackgroundColor
      } : {})
    };
    const cProps = { ...(0, _lodash.omit)(others, 'lineColor', 'backgroundColor', 'hoverColor', 'assignTabLabelRef', 'id', 'keyValue', 'linePositionClass', 'moveTab', 'onEditLabel', 'onLabelBlur', 'pinnable', 'resizable', 'value', 'incrementTab', 'isDraggingCallback', 'deleteable', 'keepTabContent'),
      onFocus: e => {
        setFocusNode(e.currentTarget);
      },
      onBlur: e => {
        setFocusNode(null);
        onLeave(e.currentTarget);
      },
      onKeyUp: e => onLeave(e.currentTarget),
      onKeyDown: this.onKeyDown,
      onMouseEnter: e => onEnter(e.currentTarget),
      tabIndex: selected ? 0 : -1,
      'aria-selected': selected,
      'aria-controls': panelId,
      ref: tab => {
        this.tabEl = tab;

        if (selected) {
          setSelectedNode(tab);
        }

        this.props.assignTabLabelRef(tab);
      },
      className,
      onClick
    };

    const flyout = this.state.flyoutOpen && this.props.toolbar && this.props.selected && /*#__PURE__*/_react.default.createElement(_flyout.Flyout, {
      className: "tab-item-flyout-container",
      placement: "bottom",
      padding: "default",
      hideArrow: true,
      domNodeToAttachTo: document.body,
      onClose: this.closeToolbar
    }, /*#__PURE__*/_react.default.createElement(_toolbar.default, {
      tabIndex: 0
    }, this.props.toolbar.map((element, i) => /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      iconId: element.icon.id,
      size: "small",
      key: i,
      className: "ba-common-toolbar__item",
      onClick: () => {
        element.handler();
        this.setState(state => ({
          flyoutOpen: !state.flyoutOpen
        }));
      },
      focusable: true,
      tabIndex: 0
    }))));

    let iconPositionClass = '';

    if (isIconBeforeLabel || iconPosition === 'left') {
      iconPositionClass = 'is-left-positioned-icon';
    } else if (iconPosition === 'top') {
      iconPositionClass = 'is-top-positioned-icon';
    } else if (iconPosition === 'bottom') {
      iconPositionClass = 'is-bottom-positioned-icon';
    }

    const isOnlyIconClass = !label ? ' is-only-icon-tab' : '';
    const labelIconSize = label ? 'small' : 'normal';
    const iconClassName = this.props.className ? this.props.className : '';
    const labelIcon = icon ? /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: `ba-common-tabList__labelIcon ${iconClassName} ${isOnlyIconClass} ${iconPositionClass}`,
      ref: node => {
        this.assignSvgIconColor((0, _reactDom.findDOMNode)(node), iconColor);
      },
      iconId: icon,
      size: labelIconSize
    }) : '';

    const dismissButton = !this.state.editActive && /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      iconId: _close_.default.id,
      size: "small",
      ref: node => {
        this.assignSvgIconColor((0, _reactDom.findDOMNode)(node), this.props.deleteIconColor);
      },
      onClick: e => {
        e.stopPropagation();

        if (onDeletePrompt) {
          this.deleteCallback();
        } else {
          deleteHandler();
        }
      }
    });

    return /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: title || this.state.label,
      delay: true,
      orient: tooltipOrient,
      display: vertical ? 'block' : 'inline-block',
      className: "flyout-wrapper ba-common-tabList__tooltip",
      onDoubleClick: this.onDoubleClickHandler,
      disabled: isDragging || this.state.flyoutOpen,
      onKeyDown: this.onKeyDown
    }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      // eslint-disable-line jsx-a11y/interactive-supports-focus, jsx-a11y/mouse-events-have-key-events
      "data-tid": `tabItem${index}`
    }, cProps, {
      onMouseOver: this.themeHoverOn,
      onMouseLeave: this.themeHoverOff,
      style: style,
      role: "tab",
      "data-index": index
    }), isOver, /*#__PURE__*/_react.default.createElement("div", {
      className: "ba-common-tabList__label__container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `ba-common-tabList__label${isOnlyIconClass}`,
      id: `label-${index}`,
      onKeyPress: this.onKeyPress,
      onClick: this.onLabelClick
    }, label ? /*#__PURE__*/_react.default.createElement(_TabLabel.default, {
      className: `ba-common-tabList__labelText ${iconPositionClass}`,
      contentEditable: !disabled && selected && editable !== false,
      changeHandler: event => {
        this.changeHandler(event, this.props.keyValue);
      },
      focusHandler: this.focusHandler,
      ref: input => {
        this.tabLabel = input;
      },
      label: label,
      textDir: textDir,
      tabButton: tabButton,
      disableDrag: disableDrag,
      enableDrag: enableDrag,
      onLabelBlur: () => {
        this.props.onLabelBlur();
      },
      hideDismiss: this.hideDismiss
    }) : '', labelIcon), dismissButton && !disabled ? /*#__PURE__*/_react.default.createElement("span", {
      className: "ba-common-tabList__itemIcon close",
      style: deleteStyles
    }, dismissButton) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: "subTitle"
    }, subTitle))), flyout);
  }

}

exports.default = TabItem;
(0, _defineProperty2.default)(TabItem, "propTypes", {
  className: _propTypes.default.string,
  panelId: _propTypes.default.string.isRequired,
  setSelectedNode: _propTypes.default.func.isRequired,
  setFocusNode: _propTypes.default.func.isRequired,
  onClick: _propTypes.default.func.isRequired,
  isDragging: _propTypes.default.bool,
  isOver: _propTypes.default.bool,
  index: _propTypes.default.number.isRequired,
  tooltipOrient: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  selected: _propTypes.default.bool,
  deleteable: _propTypes.default.bool,
  editable: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  vertical: _propTypes.default.bool,
  isIconBeforeLabel: _propTypes.default.bool,
  iconPosition: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  label: _propTypes.default.string,
  subTitle: _propTypes.default.string,
  title: _propTypes.default.string,
  keyValue: _propTypes.default.string,
  icon: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  hoverColor: _propTypes.default.string,
  deleteBackgroundColor: _propTypes.default.string,
  deleteIconColor: _propTypes.default.string,
  textColor: _propTypes.default.string,
  linePositionClass: _propTypes.default.string,
  lineColor: _propTypes.default.string,
  iconColor: _propTypes.default.string,
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  onEnter: _propTypes.default.func,
  onLeave: _propTypes.default.func,
  onEditLabel: _propTypes.default.func,
  deleteHandler: _propTypes.default.func,
  toolbar: _propTypes.default.array,
  incrementTab: _propTypes.default.func,
  onDragStart: _propTypes.default.func,
  onDeletePrompt: _propTypes.default.func,
  disableDrag: _propTypes.default.func,
  enableDrag: _propTypes.default.func,
  assignTabLabelRef: _propTypes.default.func,
  onLabelBlur: _propTypes.default.func,
  tabButton: _propTypes.default.bool
});
(0, _defineProperty2.default)(TabItem, "defaultProps", {
  isIconBeforeLabel: false,
  editable: false,
  tooltipOrient: 'bottom',
  iconPosition: 'right'
});

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var _default = {
  TAB: 'tab'
};
exports.default = _default;

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _utils = __webpack_require__(5);

var _TabsResources = _interopRequireDefault(__webpack_require__(520));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_TabsResources.default);

exports.default = _default;

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = __webpack_require__(2);

var _propTypes = _interopRequireDefault(__webpack_require__(4));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

/* eslint react/no-unused-prop-types: 'off' */
class TabPanel extends _react.Component {}

exports.default = TabPanel;
(0, _defineProperty2.default)(TabPanel, "propTypes", {
  className: _propTypes.default.string,
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  subTitle: _propTypes.default.string,
  title: _propTypes.default.string,
  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  isIconBeforeLabel: _propTypes.default.bool,
  iconPosition: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  children: _propTypes.default.node,
  slideout: _propTypes.default.bool,
  keepTabContent: _propTypes.default.bool,
  resizable: _propTypes.default.bool,
  pinnable: _propTypes.default.bool,
  resizeMaxConstraintsX: _propTypes.default.number,
  resizeMinConstraintsX: _propTypes.default.number,
  resizeMaxConstraintsY: _propTypes.default.number,
  resizeMinConstraintsY: _propTypes.default.number,
  tooltipOrient: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]) // vertical tabs

});
(0, _defineProperty2.default)(TabPanel, "defaultProps", {
  resizable: false,
  pinnable: false,
  tooltipOrient: 'bottom'
});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("react-dnd");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__25__;

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__28__;

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = require("react-measure");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/close_32");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(515);


/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Tabs = _interopRequireDefault(__webpack_require__(516));

exports.default = _Tabs.default;
exports.Tabs = _Tabs.default;

var _TabPanel = _interopRequireDefault(__webpack_require__(198));

exports.TabPanel = _TabPanel.default;

var _TabItem = _interopRequireDefault(__webpack_require__(195));

exports.TabItem = _TabItem.default;

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _flexlayout = __webpack_require__(14);

var _slideout = _interopRequireDefault(__webpack_require__(87));

var _container = _interopRequireDefault(__webpack_require__(15));

var _lodash = __webpack_require__(18);

var _TabList = _interopRequireDefault(__webpack_require__(517));

var _TabPanel = _interopRequireDefault(__webpack_require__(198));

__webpack_require__(55);

var _StringResource = _interopRequireDefault(__webpack_require__(197));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  BaPropTypes
} = _utils.propsUtils;
const {
  uniqueId,
  findIndex,
  isEqual
} = _utils.lodash;

function getTabIndex(componentChildren, tabProps) {
  const children = _react.Children.toArray(componentChildren);

  const index = findIndex(children, ({
    props
  }) => props.id === tabProps.selected);
  return index >= 0 ? index : -1;
}
/* eslint-disable react/sort-comp */


class Tabs extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      selectedIndex: getTabIndex(this.props.children, this.props),
      selectedChanged: false,
      newTabAdded: false
    });
    (0, _defineProperty2.default)(this, "_id", uniqueId('__tabs_'));
    (0, _defineProperty2.default)(this, "_renderedTabs", {});
    (0, _defineProperty2.default)(this, "_onChange", (value, id) => {
      if (this.props.selected === undefined) {
        // internally controlled
        this.setState({
          selectedIndex: id,
          selectedChanged: true
        });
      } // this part controls the toggle for tabbed slideout


      if (this.state.selectedIndex === id && this.props.slideout) {
        this.setState({
          selectedIndex: -1
        }); // this.props.onChange(value, id);
      } else {
        this.props.onChange && this.props.onChange(value, id);
      }
    });
    (0, _defineProperty2.default)(this, "deleteHandler", (value, i) => {
      const currentTab = this.state.selectedIndex;
      const obj = this.props.stateTabs;
      const arr = [];
      Object.keys(obj).forEach(v => {
        if (obj[v].props.id !== value) {
          arr.push(obj[v]);
        }
      });
      this.props.setState(arr);

      if (arr.length === 0) {
        /* If there are no tabs, select none */
        this.setState({
          selectedIndex: null
        });
      } else if (currentTab === i) {
        /* If the tab you delete is the selected tab, select the one before it, or the first tab */
        const newId = Math.max(i - 1, 0);
        this.setState({
          selectedIndex: newId,
          selectedChanged: true
        });
        this.props.onChange && this.props.onChange(arr[newId].props.id, newId);
      } else if (currentTab > this.props.children.length - 1 || currentTab > i) {
        /* If the selected index is the last tab, move left one OR the deleted one is before the selected one */
        const newId = Math.max(currentTab - 1, 0);
        this.setState({
          selectedIndex: newId,
          selectedChanged: true
        });
        this.props.onChange && this.props.onChange(arr[newId].props.id, newId);
      }
    });
    (0, _defineProperty2.default)(this, "addNewTab", () => {
      const stateTabsObject = this.props.stateTabs;
      const id = uniqueId();
      stateTabsObject.push( /*#__PURE__*/_react.default.createElement(_TabPanel.default, {
        id: id,
        key: id,
        label: `Untitled ${id}`,
        subTitle: "Subtitle"
      }, `${_StringResource.default.get('newContent')} ${id}`));
      this.setState({
        newTabAdded: true
      });
      this.props.setState(stateTabsObject);
    });
    (0, _defineProperty2.default)(this, "moveTab", (dragIndex, hoverIndex, dropped, tabId) => {
      const stateTabsObject = this.props.stateTabs;
      const dragTab = stateTabsObject[dragIndex];
      this.props.onChange && this.props.onChange(dragTab.props.id);
      this.arrayMove(stateTabsObject, dragIndex, hoverIndex);
      this.props.setState(stateTabsObject);
      this.setState({
        selectedIndex: hoverIndex
      }, () => {
        dropped && this.props.onReorder && this.props.onReorder(hoverIndex, tabId);
      });
    });
    (0, _defineProperty2.default)(this, "incrementTab", (fromIndex, direction, tabId) => {
      const tabs = this.props.stateTabs;

      if (!tabs) {
        return;
      }

      let toIndex = fromIndex + direction; // wrap position

      if (toIndex < 0) {
        toIndex = tabs.length - 1;
      }

      if (toIndex > tabs.length - 1) {
        toIndex = 0;
      }

      this.moveTab(fromIndex, toIndex, true, tabId);
    });
    (0, _defineProperty2.default)(this, "onEditLabel", (value, newLabel) => {
      const stateTabsObject = this.props.stateTabs;
      let newEl;

      _react.Children.toArray(stateTabsObject).forEach((item, index) => {
        if (item.props.id === value) {
          newEl = (0, _react.cloneElement)(item, {
            label: newLabel
          });
          stateTabsObject[index] = newEl;
        }
      });

      this.forceUpdate();
    });
    (0, _defineProperty2.default)(this, "setClickedTrue", () => {
      this.setState({
        clicked: true
      });
    });
    (0, _defineProperty2.default)(this, "setClickedFalse", () => {
      this.setState({
        clicked: false
      });
    });
  }

  componentDidMount() {
    if (this.props.scrollWhenSelected && this.tablist) {
      this.tablist.scrollTabIntoView();
    }
  }

  componentWillReceiveProps(props) {
    const i = getTabIndex(props.children, props);

    if (i >= 0 && i !== this.state.selectedIndex) {
      this.setState({
        selectedIndex: i,
        selectedChanged: true
      });
    }

    if (i < 0) {
      this.setState({
        selectedIndex: -1
      });
    }

    if (!isEqual(props.newTabContent, this.props.newTabContent)) {// this.addNewTab(props);
    }
  }

  componentDidUpdate() {
    if (this.state.newTabAdded) {
      if (this.props.scrollWhenAdded) {
        this.tablist.scrollTabIntoView(this.tablist._innerNode.firstChild.lastChild // eslint-disable-line no-underscore-dangle
        );
      }

      this.setState({
        newTabAdded: false
      }); // eslint-disable-line react/no-did-update-set-state
    }

    if (this.state.selectedChanged) {
      if (this.props.scrollWhenSelected) {
        this.tablist.scrollTabIntoView();
      }

      this.setState({
        selectedChanged: false
      }); // eslint-disable-line react/no-did-update-set-state
    }
  }

  arrayMove(arr, fromIndex, toIndex) {
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  render() {
    const {
      overflow,
      align,
      multiLine,
      vertical,
      slideout,
      pinAll,
      draggable,
      className,
      style,
      pageLevel,
      tabButton,
      addTabToolTipText,
      textDir,
      scrollButtonsBackgroundColor,
      scrollButtonsTextColor,
      scrollButtonsHoverColor,
      onDeletePrompt,
      placement
    } = this.props;
    let {
      deleteable,
      editable,
      addable
    } = this.props;

    if (pageLevel) {
      deleteable = true;
      editable = true;
      addable = true;
    }

    const {
      selectedIndex
    } = this.state;
    let linePositionClass;
    let tabsPlacementClass;
    let verticalPlacement;

    if (placement) {
      tabsPlacementClass = placement ? `tabs-placement-${placement}` : false;
      verticalPlacement = placement === 'left' || placement === 'right';
    } else {
      verticalPlacement = vertical;
    }

    if (!tabButton) {
      linePositionClass = 'line-position-bottom';

      if (verticalPlacement) {
        linePositionClass = 'line-position-left';
      }

      if (this.props.linePosition) {
        linePositionClass = `line-position-${this.props.linePosition}`;
      }
    } else if (tabButton) {
      linePositionClass = 'line-position-none';
    }

    const classNames = (0, _utils.classnames)('ba-common-tabList__container', linePositionClass, tabsPlacementClass, {
      deleteable,
      multiLine,
      vertical: verticalPlacement,
      slideout,
      clicked: this.state.clicked,
      [`align_${align}`]: align === 'center' || align === 'end'
    });

    const children = _react.Children.toArray(this.props.children).filter(child => child !== null);

    const renderedTabs = {};

    const result = /*#__PURE__*/_react.default.createElement("div", {
      direction: "column",
      className: `${classNames} ${className}`,
      style: style,
      onMouseDown: this.setClickedTrue,
      onKeyUp: this.setClickedFalse
    }, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      gutter: [1, 0, 0],
      style: {
        position: 'relative'
      },
      ref: node => {
        slideout && !this.state.node && this.setState({
          node
        });
      }
    }, /*#__PURE__*/_react.default.createElement(_TabList.default, {
      ref: e => this.tablist = e,
      scrollButtonsBackgroundColor: scrollButtonsBackgroundColor,
      scrollButtonsTextColor: scrollButtonsTextColor,
      scrollButtonsHoverColor: scrollButtonsHoverColor,
      draggable: draggable,
      selectedIndex: selectedIndex,
      deleteable: deleteable,
      multiLine: multiLine,
      editable: editable,
      vertical: verticalPlacement,
      tabButton: tabButton,
      addable: addable,
      textDir: textDir,
      deleteHandler: this.deleteHandler,
      onDeletePrompt: onDeletePrompt,
      onChange: this._onChange,
      onEditLabel: this.onEditLabel,
      linePositionClass: linePositionClass,
      addTabToolTipText: addTabToolTipText,
      onAddButtonClick: () => {
        (this.props.onAddButtonClick || this.addNewTab)(); // this.props.onAddButtonClick
      },
      moveTab: this.moveTab,
      incrementTab: this.incrementTab,
      options: _react.Children.map(children, ({
        props
      }) => ({ ...(0, _lodash.omit)(props, 'children', 'id', 'pinnable', 'resizable', 'resizeMaxConstraintsX', 'resizeMinConstraintsX'),
        panelId: `${this._id}-${props.id}_panel`,
        value: props.id,
        editable: !slideout && props.editable,
        toolbar: this.props.toolbar
      }))
    }), slideout && _react.Children.map(children, (child, i) => {
      const {
        props
      } = child;
      const selected = selectedIndex === i; // track if tab is previously rendered

      const renderTab = !props.disabled && (props.keepTabContent && this._renderedTabs[props.id] || selected);
      renderedTabs[props.id] = renderTab;
      const tabId = `${this._id}-${props.id}`;
      const slideoutProps = {
        active: selected,
        resizable: child.props.resizable,
        resizeMaxConstraintsX: child.props.resizeMaxConstraintsX,
        resizeMinConstraintsX: child.props.resizeMinConstraintsX,
        resizeMaxConstraintsY: child.props.resizeMaxConstraintsY,
        resizeMinConstraintsY: child.props.resizeMinConstraintsY,
        containerRef: this.state.node,
        width: child.props.width
      };

      if (!pinAll && !child.props.pinnable) {
        slideoutProps.onClickAway = () => {
          if (selected) {
            this.setState({
              selectedIndex: -1
            });
          }
        };
      }

      return /*#__PURE__*/_react.default.createElement(_slideout.default, slideoutProps, /*#__PURE__*/_react.default.createElement("div", {
        key: props.id,
        id: `${tabId}_panel`,
        role: "tabpanel",
        className: "tabpanel",
        "aria-labelledby": tabId,
        "aria-hidden": !selected,
        overflow: overflow
      }, _react.default.Children.map(props.children, innerChild => innerChild)));
    })), !slideout && /*#__PURE__*/_react.default.createElement(_container.default, {
      relative: true,
      overflow: overflow,
      className: "ba-common-tabList__innerContainer"
    }, _react.Children.map(children, (child, i) => {
      const {
        props
      } = child;
      const selected = selectedIndex === i; // track if tab is previously rendered

      const renderTab = !props.disabled && (props.keepTabContent && this._renderedTabs[props.id] || selected);
      renderedTabs[props.id] = renderTab;
      const tabId = `${this._id}-${props.id}`;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: props.id,
        id: `${tabId}_panel`,
        role: "tabpanel",
        className: "tabpanel",
        "aria-labelledby": tabId,
        style: {
          display: selected ? 'block' : 'none'
        },
        "aria-hidden": !selected,
        overflow: overflow
      }, renderTab ? _react.default.Children.map(props.children, innerChild => innerChild) : null);
    })));

    this._renderedTabs = renderedTabs;
    return result;
  }

}

exports.default = Tabs;
(0, _defineProperty2.default)(Tabs, "propTypes", {
  draggable: _propTypes.default.bool,
  selected: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  children: _propTypes.default.node.isRequired,
  onChange: _propTypes.default.func,
  onAddButtonClick: _propTypes.default.func,
  addable: _propTypes.default.bool,
  scrollWhenSelected: _propTypes.default.bool,
  scrollWhenAdded: _propTypes.default.bool,
  onReorder: _propTypes.default.func,
  setState: _propTypes.default.func,
  onDeletePrompt: _propTypes.default.func,
  deleteable: _propTypes.default.bool,
  multiLine: _propTypes.default.bool,
  editable: _propTypes.default.bool,
  pageLevel: BaPropTypes.deprecated('It will be removed soon, use "editable" and "deleteable" properties instead.'),
  vertical: _propTypes.default.bool,
  placement: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  tabButton: _propTypes.default.bool,
  overflow: _propTypes.default.string,
  className: _propTypes.default.string,
  linePosition: _propTypes.default.string,
  addTabToolTipText: _propTypes.default.string,
  newTabContent: _propTypes.default.object,
  stateTabs: _propTypes.default.array,
  slideout: _propTypes.default.bool,
  pinAll: _propTypes.default.bool,
  toolbar: _propTypes.default.array,
  align: _propTypes.default.oneOf(['start', 'end', 'left', 'center', 'right']),
  style: _propTypes.default.object,
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  scrollButtonsBackgroundColor: _propTypes.default.string,
  scrollButtonsTextColor: _propTypes.default.string,
  scrollButtonsHoverColor: _propTypes.default.string
});
(0, _defineProperty2.default)(Tabs, "defaultProps", {
  scrollWhenSelected: true,
  scrollWhenAdded: false,
  align: 'start',
  pinAll: false,
  className: '',
  style: {}
});

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactMeasure = _interopRequireDefault(__webpack_require__(29));

var _utils = __webpack_require__(5);

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _tooltip = _interopRequireDefault(__webpack_require__(16));

var _add_ = _interopRequireDefault(__webpack_require__(71));

var _lodash = __webpack_require__(18);

var _TabItem = _interopRequireWildcard(__webpack_require__(195));

var _TabScrollButton = _interopRequireWildcard(__webpack_require__(519));

var _StringResource = _interopRequireDefault(__webpack_require__(197));

__webpack_require__(55);

/* eslint-disable react/no-did-update-set-state */

/* eslint-disable react/no-unused-state */

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  uniqueId
} = _utils.lodash;
/* eslint-disable react/sort-comp */
// TODO: might be able to export two a version of TabList(TabList & DnDTabList) later

class TabList extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      lineWidth: 0,
      lineLeft: 0,
      lineWidth2: 0,
      lineLeft2: 0
    });
    (0, _defineProperty2.default)(this, "_id", uniqueId('__tabList_'));
    (0, _defineProperty2.default)(this, "_enter", n => {
      this.setState({
        lineWidth2: n.offsetWidth,
        lineLeft2: n.offsetLeft
      });
    });
    (0, _defineProperty2.default)(this, "_leave", () => {
      this.setState(state => ({
        lineWidth2: state.lineWidth,
        lineLeft2: state.lineLeft
      }));
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", e => {
      const {
        keyCode
      } = e;
      const {
        options
      } = this.props;
      let i = this.props.selectedIndex;

      switch (keyCode) {
        case 36: // home
        // fall through

        case 38: // up arrow
        // fall through

        case 37:
          if (keyCode === 37 && this.props.vertical || keyCode === 38 && !this.props.vertical) {
            break;
          } // left arrow


          if (e.altKey || keyCode === 36) {
            i = 0;
          } else {
            i -= 1;

            if (i < 0) {
              i = options.length - 1;
            }
          }

          e.preventDefault();
          break;

        case 35: // end
        // fall through

        case 40: // down arrow
        // fall through

        case 39:
          if (keyCode === 39 && this.props.vertical || keyCode === 40 && !this.props.vertical) {
            break;
          } // right arrow


          if (e.altKey || keyCode === 35) {
            i = options.length - 1;
          } else {
            i += 1;

            if (i === options.length) {
              i = 0;
            }
          }

          e.preventDefault();
          break;

        default:
      }

      this.props.onChange(options[i].value, i);
    });
    (0, _defineProperty2.default)(this, "_onClick", (value, i) => {
      this.props.onChange(value, i);
    });
    (0, _defineProperty2.default)(this, "_onScroll", () => {
      this.setState({
        scrollLeft: this._innerNode.firstChild.scrollLeft > 4,
        scrollTop: this._innerNode.firstChild.scrollTop > 4,
        scrollRight: this._innerNode.firstChild.scrollWidth - this._innerNode.firstChild.scrollLeft - this._innerNode.firstChild.offsetWidth > 4,
        scrollBottom: this._tabList.lastElementChild.offsetTop + this._tabList.lastElementChild.offsetHeight - (this._tabList.offsetHeight + this._innerNode.firstChild.scrollTop) > 4
      });
    });
    (0, _defineProperty2.default)(this, "_onWheel", e => {
      const {
        deltaY
      } = e;
      const {
        deltaX
      } = e;
      this._innerNode.firstChild.scrollTop += deltaY;
      this._innerNode.firstChild.scrollLeft += deltaX;
    });
    (0, _defineProperty2.default)(this, "scrollList", direction => {
      if (direction === 'left') {
        this._innerNode.firstChild.scrollLeft -= 80;
      }

      if (direction === 'right') {
        this._innerNode.firstChild.scrollLeft += 80;
      }

      if (direction === 'top') {
        this._innerNode.firstChild.scrollTop -= 80;
      }

      if (direction === 'bottom') {
        this._innerNode.firstChild.scrollTop += 80;
      }
    });
    (0, _defineProperty2.default)(this, "scrollTabIntoView", tabParam => {
      let tab = tabParam;

      let viewableArea = this._innerNode.firstChild.getBoundingClientRect();

      if (!tab) {
        tab = this._selectedNode;
      }

      if (tab) {
        let position = tab.getBoundingClientRect();

        while (Math.floor(position.left) < Math.floor(viewableArea.left)) {
          this._innerNode.firstChild.scrollLeft -= 100;
          viewableArea = this._innerNode.firstChild.getBoundingClientRect();
          position = tab.getBoundingClientRect();
        }

        while (Math.floor(position.right) > Math.floor(viewableArea.right)) {
          this._innerNode.firstChild.scrollLeft += 100;
          viewableArea = this._innerNode.firstChild.getBoundingClientRect();
          position = tab.getBoundingClientRect();
        }

        while (Math.floor(position.top) < Math.floor(viewableArea.top)) {
          this._innerNode.firstChild.scrollTop -= 100;
          viewableArea = this._innerNode.firstChild.getBoundingClientRect();
          position = tab.getBoundingClientRect();
        }

        while (Math.floor(position.bottom) > Math.floor(viewableArea.bottom)) {
          this._innerNode.firstChild.scrollTop += 100;
          viewableArea = this._innerNode.firstChild.getBoundingClientRect();
          position = tab.getBoundingClientRect();
        }
      }
    });
    (0, _defineProperty2.default)(this, "_setSelectedNode", node => {
      this._selectedNode = node;
    });
    (0, _defineProperty2.default)(this, "_setFocusNode", nodeParam => {
      let node = nodeParam;

      if (!node) {
        node = this._selectedNode ? this._selectedNode : null;
      }

      this._focusNode = node;
    });
    (0, _defineProperty2.default)(this, "_refLine", node => {
      this._line = node;
    });
    (0, _defineProperty2.default)(this, "_refLine2", node => {
      this._line2 = node;
    });
    (0, _defineProperty2.default)(this, "_refTabList", node => {
      this._tabList = node;
    });
    (0, _defineProperty2.default)(this, "_refInner", node => {
      this._innerNode = node;
    });
    (0, _defineProperty2.default)(this, "deleteHandler", (value, i) => {
      this.props.deleteHandler && this.props.deleteHandler(value, i);
    });
    (0, _defineProperty2.default)(this, "_enableDrag", () => {
      this.setState({
        dragDisabled: false
      });
    });
    (0, _defineProperty2.default)(this, "_disableDrag", () => {
      this.setState({
        dragDisabled: true
      });
    });
    (0, _defineProperty2.default)(this, "tabLabelRef", {});
    (0, _defineProperty2.default)(this, "onLabelBlur", i => () => {
      // using set state to force component to wait to update between switching between TabItem and TabItemDnD before calling .focus()
      this.setState({}, () => {
        this.tabLabelRef[i].focus();
      });
    });
    (0, _defineProperty2.default)(this, "assignTabLabelRef", (ref, i) => {
      this.tabLabelRef[i] = ref;
    });
    (0, _defineProperty2.default)(this, "_isDragging", value => {
      this.setState({
        dragging: value
      });
    });
  }

  componentDidMount() {
    if (this._selectedNode) {
      this.setState({
        lineWidth: this._selectedNode.offsetWidth,
        lineLeft: this._selectedNode.offsetLeft,
        lineWidth2: this._selectedNode.offsetWidth,
        lineLeft2: this._selectedNode.offsetLeft
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this._selectedNode === null || this._selectedNode === -1 || this._selectedNode === undefined) {
      return;
    }

    const lineWidth = this._selectedNode.offsetWidth;
    const lineLeft = this._selectedNode.offsetLeft;

    if (this.props.selectedIndex !== prevProps.selectedIndex) {
      // assign the line width and height based on the selected node
      this.setState({
        lineWidth,
        lineLeft,
        lineWidth2: lineWidth,
        lineLeft2: lineLeft
      }, // if the focus node is set, this means that focus is on a tab
      // since the selected tab has changed, we need to refocus the new selected node
      this._focusNode ? () => {
        this._selectedNode.focus();
      } : null);
    } else if (lineWidth !== this.state.lineWidth || lineLeft !== this.state.lineLeft) {
      // the UI changed and we must resize the lines
      this.setState({
        lineWidth,
        lineLeft,
        lineWidth2: lineWidth,
        lineLeft2: lineLeft
      });
    }

    if (this.props !== prevProps) {
      this._onScroll();
    }
  }

  render() {
    const {
      options,
      selectedIndex,
      onAddButtonClick,
      moveTab,
      incrementTab,
      onEditLabel,
      vertical,
      textDir,
      linePositionClass,
      draggable,
      editable,
      tabButton,
      addable,
      addTabToolTipText,
      scrollButtonsBackgroundColor,
      scrollButtonsTextColor,
      scrollButtonsHoverColor,
      onDeletePrompt
    } = this.props;
    const {
      scrollLeft,
      scrollRight,
      scrollTop,
      scrollBottom
    } = this.state;
    let {
      deleteable
    } = this.props;

    const onAddButtonKeyDown = e => {
      // enter key or space bar will simulate a click
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        onAddButtonClick && onAddButtonClick();
      }
    };

    let isOnlyIconClass = ' is-only-icon-tab-list';
    options.forEach(({
      label
    }) => {
      if (label) {
        isOnlyIconClass = '';
      }
    });
    const listIsDragged = this.state.dragging;
    deleteable = deleteable && !listIsDragged; // Only in use TabScrollButtonDnd if drag and drop is enabled, besides that use regular TabScrollButton

    const TabScrollButtonComponent = draggable ? _TabScrollButton.TabScrollButtonDnd : _TabScrollButton.default;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _utils.classnames)(`ba-common-tabList${isOnlyIconClass}`, {
        vertical
      }, {
        deleteable
      }, {
        editable
      }, {
        tabButton
      }, {
        addable
      })
    }, /*#__PURE__*/_react.default.createElement(_reactMeasure.default, {
      onResize: this._onScroll,
      whitelist: ['width']
    }, ({
      measureRef
    }) => /*#__PURE__*/_react.default.createElement("div", {
      ref: measureRef
    }, /*#__PURE__*/_react.default.createElement("nav", {
      className: "ba-common-tabList__inner",
      ref: this._refInner
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: `ba-common-tabList__list ${linePositionClass}`,
      onKeyDown: this._onKeyDown,
      role: "tablist",
      ref: this._refTabList,
      onScroll: this._onScroll,
      onWheel: this._onWheel.bind(this)
    }, this.props.options.map((props, i) => {
      const isDnD = draggable && !this.state.dragDisabled;
      const TabItems = isDnD ? _TabItem.TabItemDnD : _TabItem.default;
      const tabItemDnDProps = {
        incrementTab,
        isDraggingCallback: this._isDragging
      };
      return /*#__PURE__*/_react.default.createElement(TabItems, (0, _extends2.default)({}, (0, _lodash.omit)(props, 'value'), isDnD ? tabItemDnDProps : {}, {
        deleteHandler: () => this.deleteHandler(props.value, i),
        key: props.value,
        keyValue: props.value,
        textDir: textDir,
        selected: selectedIndex === i,
        editable: editable,
        deleteable: deleteable,
        vertical: vertical,
        tabButton: tabButton,
        onClick: () => this._onClick(props.value, i),
        onEnter: this._enter,
        onLeave: this._leave,
        setSelectedNode: this._setSelectedNode,
        setFocusNode: this._setFocusNode,
        disableDrag: this._disableDrag,
        enableDrag: this._enableDrag,
        index: i,
        moveTab: moveTab,
        onEditLabel: onEditLabel,
        linePositionClass: linePositionClass,
        assignTabLabelRef: ref => {
          this.tabLabelRef[i] = ref;
        },
        onDeletePrompt: onDeletePrompt,
        onLabelBlur: this.onLabelBlur(i)
      }));
    })), addable ? /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      orient: "top",
      title: addTabToolTipText,
      delay: true
    }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      "aria-label": addTabToolTipText,
      iconId: _add_.default.id,
      focusable: true,
      tabIndex: "0",
      className: "addNewIcon",
      onKeyDown: onAddButtonKeyDown,
      onClick: onAddButtonClick
    })) : ''))), /*#__PURE__*/_react.default.createElement(TabScrollButtonComponent, {
      scrolling: scrollBottom,
      bottom: true,
      scrollHandler: () => this.scrollList('bottom'),
      onClick: () => this.scrollList('bottom'),
      backgroundColor: scrollButtonsBackgroundColor,
      textColor: scrollButtonsTextColor,
      hoverColor: scrollButtonsHoverColor
    }), /*#__PURE__*/_react.default.createElement(TabScrollButtonComponent, {
      scrolling: scrollTop,
      top: true,
      scrollHandler: () => this.scrollList('top'),
      onClick: () => this.scrollList('top'),
      backgroundColor: scrollButtonsBackgroundColor,
      textColor: scrollButtonsTextColor,
      hoverColor: scrollButtonsHoverColor
    }), /*#__PURE__*/_react.default.createElement(TabScrollButtonComponent, {
      scrolling: scrollLeft,
      left: true,
      scrollHandler: () => this.scrollList('left'),
      onClick: () => this.scrollList('left'),
      backgroundColor: scrollButtonsBackgroundColor,
      textColor: scrollButtonsTextColor,
      hoverColor: scrollButtonsHoverColor
    }), /*#__PURE__*/_react.default.createElement(TabScrollButtonComponent, {
      scrolling: scrollRight,
      right: true,
      scrollHandler: () => this.scrollList('right'),
      onClick: () => this.scrollList('right'),
      backgroundColor: scrollButtonsBackgroundColor,
      textColor: scrollButtonsTextColor,
      hoverColor: scrollButtonsHoverColor
    }));
  }

}

exports.default = TabList;
(0, _defineProperty2.default)(TabList, "propTypes", {
  draggable: _propTypes.default.bool,
  selectedIndex: _propTypes.default.number.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string,
    icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
    isIconBeforeLabel: _propTypes.default.bool,
    iconPosition: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
    title: _propTypes.default.string
  })).isRequired,
  onChange: _propTypes.default.func,
  onAddButtonClick: _propTypes.default.func,
  deleteHandler: _propTypes.default.func,
  moveTab: _propTypes.default.func,
  incrementTab: _propTypes.default.func,
  onDeletePrompt: _propTypes.default.func,
  deleteable: _propTypes.default.bool,
  editable: _propTypes.default.bool,
  multiLine: _propTypes.default.bool,
  vertical: _propTypes.default.bool,
  tabButton: _propTypes.default.bool,
  addable: _propTypes.default.bool,
  setState: _propTypes.default.func,
  onEditLabel: _propTypes.default.func,
  newTabContent: _propTypes.default.object,
  linePositionClass: _propTypes.default.string,
  addTabToolTipText: _propTypes.default.string,
  scrollButtonsBackgroundColor: _propTypes.default.string,
  scrollButtonsTextColor: _propTypes.default.string,
  scrollButtonsHoverColor: _propTypes.default.string,
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto'])
});
(0, _defineProperty2.default)(TabList, "defaultProps", {
  addTabToolTipText: _StringResource.default.get('addNewTab')
});

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _truncatedtext = _interopRequireDefault(__webpack_require__(13));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  resolveBaseTextDir
} = _utils.bidiUtils;
/**
 * TabLabel is an editable span element that supports cancel/revert via the esc key
 */

class TabLabel extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_onFocus", e => {
      if (this.props.disableDrag) {
        this.props.disableDrag();
      }

      this.labelInitialValue = e.target.textContent;

      this._selectAllTextInTarget(e.target);

      this.props.focusHandler && this.props.focusHandler(true);
    });
    (0, _defineProperty2.default)(this, "_selectAllTextInTarget", target => {
      if (this._isCreateTextRangeSupported()) {
        const range = document.body.createTextRange();
        range.moveToElementText(target);
        range.select();
      } else if (this._isGetSelectionSupported()) {
        const selection = window.getSelection();
        const newRange = document.createRange();
        newRange.selectNodeContents(target);
        selection.removeAllRanges();
        selection.addRange(newRange);
      }
    });
    (0, _defineProperty2.default)(this, "_onBlur", e => {
      const {
        enableDrag,
        changeHandler,
        onLabelBlur
      } = this.props;

      if (e.target.textContent === '') {
        e.target.textContent = this.labelInitialValue;
      }

      changeHandler(e);

      if (enableDrag) {
        enableDrag();
      }

      onLabelBlur && onLabelBlur();
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", e => {
      e.stopPropagation();

      switch (e.keyCode) {
        // esc key - revert edit
        case 27:
          e.target.textContent = this.labelInitialValue;
          this.props.focusOnComplete && this.props.focusOnComplete();
          this.props.onLabelBlur();
          break;
        // enter - done focus on parent tab

        case 13:
          this.props.focusOnComplete && this.props.focusOnComplete();
          this.props.onLabelBlur();
          break;

        default:
      }
    });
    (0, _defineProperty2.default)(this, "_onClick", () => {
      this.focusOnLabel();
    });
  }

  _isCreateTextRangeSupported() {
    if (document.body.createTextRange) return true;
    return false;
  }

  _isGetSelectionSupported() {
    if (window.getSelection) return true;
    return false;
  }

  focusOnLabel() {
    if (this.props.contentEditable) {
      this.labelInput.focus();
    }
  }

  render() {
    const {
      className,
      contentEditable,
      label,
      style,
      textDir
    } = this.props;
    const defaultProps = {
      className,
      tabIndex: -1,
      ref: input => {
        this.labelInput = input;
      },
      style
    };

    if (!contentEditable) {
      return /*#__PURE__*/_react.default.createElement("span", defaultProps, /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
        textDir: resolveBaseTextDir(label, textDir, false),
        value: label,
        allowTooltip: false
      }));
    }

    return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, defaultProps, {
      contentEditable: contentEditable,
      onBlur: this._onBlur,
      onFocus: this._onFocus,
      onKeyDown: this._onKeyDown,
      onClick: this._onClick,
      suppressContentEditableWarning: "true",
      dir: resolveBaseTextDir(label, textDir, false)
    }), label);
  }

}

exports.default = TabLabel;
(0, _defineProperty2.default)(TabLabel, "propTypes", {
  className: _propTypes.default.string,
  contentEditable: _propTypes.default.bool,
  changeHandler: _propTypes.default.func.isRequired,
  focusOnComplete: _propTypes.default.func,
  focusHandler: _propTypes.default.func,
  label: _propTypes.default.string.isRequired,
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  style: _propTypes.default.object,
  disableDrag: _propTypes.default.func,
  enableDrag: _propTypes.default.func,
  onLabelBlur: _propTypes.default.func
});
(0, _defineProperty2.default)(TabLabel, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;
exports.default = exports.TabScrollButtonDnd = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _reactDnd = __webpack_require__(23);

var _chevronRight_ = _interopRequireDefault(__webpack_require__(82));

var _ItemTypes = _interopRequireDefault(__webpack_require__(196));

__webpack_require__(55);

var _dec, _class, _class2, _temp;

const dropTarget = {};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

let TabScrollButtonDnd = (_dec = (0, _reactDnd.DropTarget)(_ItemTypes.default.TAB, dropTarget, collect), _dec(_class = (_temp = _class2 = class TabScrollButtonDnd extends _react.Component {
  render() {
    const {
      connectDropTarget,
      ...other
    } = this.props;
    return connectDropTarget( /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(TabScrollButton, other)));
  }

}, (0, _defineProperty2.default)(_class2, "propTypes", {
  connectDropTarget: _propTypes.default.func.isRequired
}), _temp)) || _class);
exports.TabScrollButtonDnd = TabScrollButtonDnd;

class TabScrollButton extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "themeHoverOn", () => {
      this.setState({
        themeHover: true
      });
    });
    (0, _defineProperty2.default)(this, "themeHoverOff", () => {
      this.setState({
        themeHover: false
      });
    });
    this.state = {
      scrollIntervalId: null,
      themeHover: false
    };
  }

  componentDidUpdate(prevProps) {
    // check when the hover state has been entered or exited
    if (prevProps.isOver !== this.props.isOver) {
      if (this.props.isOver === true) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          scrollIntervalId: setInterval(() => {
            this.props.scrollHandler();
          }, 1000)
        });
      } else {
        clearInterval(this.state.scrollIntervalId);
      }
    }
  }

  getShadowStyle() {
    const {
      left,
      right,
      textColor = 'black'
    } = this.props;
    let style;

    if (left) {
      style = {
        boxShadow: `-6px 0px 12px 2px ${textColor}`
      };
    } else if (right) {
      style = {
        boxShadow: `-6px 0px 12px -8px ${textColor}`
      };
    }

    return style;
  }

  configureAndGetWrapperStyling() {
    const {
      backgroundColor,
      textColor,
      hoverColor
    } = this.props;
    const themeBackgroundColor = this.state.themeHover && hoverColor ? hoverColor : backgroundColor;
    const shadowStyle = this.getShadowStyle();
    const style = { ...(backgroundColor || hoverColor ? {
        backgroundColor: themeBackgroundColor
      } : {}),
      ...(textColor ? {
        color: this.props.textColor
      } : {}),
      ...shadowStyle
    };
    return style;
  }

  render() {
    const {
      bottom,
      top,
      left,
      right,
      onClick,
      scrolling
    } = this.props;
    const wrapperStyle = this.configureAndGetWrapperStyling();
    return /*#__PURE__*/_react.default.createElement("div", {
      // eslint-disable-line jsx-a11y/click-events-have-key-events
      className: (0, _utils.classnames)('ba-common-tabList__edge__wrapper', {
        visible: scrolling
      }, {
        bottom
      }, {
        top
      }, {
        left
      }, {
        right
      }),
      onClick: onClick,
      onMouseEnter: this.themeHoverOn,
      onMouseLeave: this.themeHoverOff,
      style: wrapperStyle
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _utils.classnames)('ba-common-tabList__edge')
    }), /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: "chevron-icon",
      iconId: _chevronRight_.default.id
    }));
  }

}

exports.default = TabScrollButton;
(0, _defineProperty2.default)(TabScrollButton, "propTypes", {
  scrolling: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  bottom: _propTypes.default.bool,
  top: _propTypes.default.bool,
  right: _propTypes.default.bool,
  left: _propTypes.default.bool,
  scrollHandler: _propTypes.default.func.isRequired,
  isOver: _propTypes.default.bool,
  backgroundColor: _propTypes.default.string,
  textColor: _propTypes.default.string,
  hoverColor: _propTypes.default.string
});

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

var amdi18n={"__root":{"addNewTab":"Add new tab","newContent":"Content for tab"},"__cs":{"addNewTab":"Přidat novou kartu","newContent":"Obsah karty"},"__da":{"addNewTab":"Tilføj et nyt skilleblad","newContent":"Indhold til skilleblad"},"__de":{"addNewTab":"Neue Registerkarte hinzufügen","newContent":"Inhalt der Registerkarte"},"__es":{"addNewTab":"Añadir nueva pestaña","newContent":"Contenido para pestaña"},"__fi":{"addNewTab":"Lisää uusi välilehti","newContent":"Välilehden sisältö"},"__fr":{"addNewTab":"Ajouter un nouvel onglet","newContent":"Contenu de l'onglet"},"__hr":{"addNewTab":"Dodaj novu karticu","newContent":"Sadržaj za karticu"},"__hu":{"addNewTab":"Új lap hozzáadása","newContent":"Lap tartalma"},"__it":{"addNewTab":"Aggiungi nuova scheda","newContent":"Contenuto per la scheda"},"__ja":{"addNewTab":"新規タブの追加","newContent":"タブのコンテンツ"},"__kk":{"addNewTab":"Жаңа қойындыны қосу","newContent":"Қойындыға арналған мазмұн"},"__ko":{"addNewTab":"새 탭 추가","newContent":"탭에 대한 컨텐츠"},"__nb":{"addNewTab":"Legg til ny flipp","newContent":"Innhold for flipp"},"__nl":{"addNewTab":"Nieuw tabblad toevoegen","newContent":"Inhoud voor tabblad"},"__no":{"addNewTab":"Legg til ny flipp","newContent":"Innhold for flipp"},"__pl":{"addNewTab":"Dodaj nową kartę","newContent":"Zawartość karty"},"__pt":{"addNewTab":"Incluir nova guia","newContent":"Conteúdo para guia"},"__pt-br":{"addNewTab":"Incluir nova guia","newContent":"Conteúdo para guia"},"__ro":{"addNewTab":"Adăugare filă nouă","newContent":"Conţinut pentru filă"},"__ru":{"addNewTab":"Добавить новую вкладку","newContent":"Содержимое для вкладки"},"__sl":{"addNewTab":"Dodaj nov zavihek","newContent":"Vsebina za zavihek"},"__sv":{"addNewTab":"Lägg till ny flik","newContent":"Innehåll för flik"},"__th":{"addNewTab":"เพิ่มแท็บใหม่","newContent":"เนื้อหาสำหรับแท็บ"},"__tr":{"addNewTab":"Yeni sekme ekle","newContent":"Sekme içeriği"},"__zh":{"addNewTab":"添加新选项卡","newContent":"选项卡的内容"},"__zh-cn":{"addNewTab":"添加新选项卡","newContent":"选项卡的内容"},"__zh-hk":{"addNewTab":"新增標籤","newContent":"標籤的內容"},"__zh-mo":{"addNewTab":"新增標籤","newContent":"標籤的內容"},"__zh-sg":{"addNewTab":"添加新选项卡","newContent":"选项卡的内容"},"__zh-tw":{"addNewTab":"新增標籤","newContent":"標籤的內容"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Tabs_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(151);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Tabs_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Tabs_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Tabs_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Tabs_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/add_32");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/chevron--right_32.js");

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__87__;

/***/ })

},[[514,0]]]);
});